import { Product } from "data/data";
import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useCartDataProvider } from "../../contaxt/CartProductContext";
import { useLocation } from "react-router-dom";
import   axios  from "axios";
import { AxiosResponse } from "axios";
import { FormProvider, useForm } from "react-hook-form";
import Card from "shared/Card";
import "../../App.css";
import appConfig from "configs/app.config";
import OrderSummary from "./OrderSummary";
import { getHeaders } from "services/BaseService";
import {
  loadAcceptJs,
  tokenizeCardWithAcceptJs,
  tokenizeCardWithAcceptJsWithCredentials,
  getBasilCredentials,
  parseExpiration,
} from "utils/acceptJs";
import {
  triggerKanopyTokenization,
  tokenizeForDelivery,
} from "utils/kanopyTokenJs";
import {
  isKanopyGateway,
  getKanopyDeviceGuid,
  getKanopyApiKey,
  getBasilKanopyDeviceGuid,
  getBasilKanopyApiKey,
} from "contaxt/OnlineOrderSettingsContext";
import Cookies from "js-cookie";
import PaymentMethod from "./PaymentMethod";
import DeliveryOptionPopup from "./DeliveryOptionsPopup";
interface MyResponseData {
  Body: string;
  // Add other properties if necessary
}
interface ResponseData {
  // totalAmount: number;
  orderNo: number;
}
interface TransIdResponse {
  transId: string;
  success: boolean;
  description: string;
  // Add other properties as needed
}
interface PaymentResponseData {
  orderResponseBody: TransIdResponse;
  feeResponseBody: DeliveryTransIdResponse;
  orderId: number;
  success: boolean;
  "Delivery Tracker Link": string;
}
interface DeliveryTransIdResponse {
  transId: string;
  success: boolean;
  description: string;
  // Add other properties as needed
}
interface Payment {
  address1: string;
  address2: string;
  city: string;

  state: string;

  zip: string;
  country: string;
}

export type CardData = {
  cardNumber: string;
  cardType: string;
  firstName: string;
  lastName: string;
  profileId: string;
  address: string;
  city: string;
  state: string;
  zip: string;
};
export interface Card {
  payment: {
    creditCard: {
      cardNumber: string;
      cardType: string;
      /** Present for Kanopy saved-card rows and Authorize.net profiles when returned by API */
      expirationDate?: string;
    };
  };
  billTo: {
    /** Kanopy customer id when applicable */
    customerId?: string;
    firstName: string;
    lastName: string;
    profileId: string;
    address: string;
    city: string;
    state: string;
    zip: string;
  };
  customerPaymentProfileId: string;
}
export interface CardsData {
  cardNumber: string;
  expirationDate: string;
  CVC: string;
  firstname: string;
  lastname: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  payment: Payment;
}
interface DeliveryOption {
  id: string;
  provider: string;
  price: number;
  pickup_mins_from_now: number;
  delivery_mins_from_now: number;
}

const CheckoutPage = () => {
  // const LeadTime = localStorage.getItem("onlineOrderSettingsLeadTime");
  const { Products, dispatch, searchProduct }: any = useCartDataProvider();
  const [authNet, setAuthNet] = useState("");
  const [responseData, setResponseData] = useState<ResponseData | null>(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [greenFlag, setGreenFlag] = useState(false);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [pickUpTime, setPickUpTime] = useState<string>("");
  const [isAsap, setIsAsap] = useState(false);
  const [selectTime, setSelectedTime] = useState(false);
  const [selectedTip, setSelectedTip] = useState("");
  const [selectedDeliveryTip, setSelectedDeliveryTip] = useState("");
  const [customTip, setCustomTip] = useState("0.00");
  const [storedOrderFee, setStoredOrderFee] = useState<number>(0);
  const [storedOrderFeeLabel, setStoredOrderFeeLabel] = useState("");
  const location = useLocation();
  const reOrderData = location.state?.item ? location.state.item : null;
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [carterror, setCartError] = useState<string>("");
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [pause, setPause] = useState<string | null>(null);
  const [isPaymentProcessing, setIsPaymentProcessing] = useState(false);
  const [somethingWrong, setSomethingWrong] = useState(false);
  const [isQuotesProcessing, setIsQuotesProcessing] = useState(false);
  const [historyOrders, setHistoryOrders] = useState<any>([]);
  const [subTotal, setsubTotal] = useState<number>(0);
  const { firstname, lastname, phoneNumber, email } = location.state || {};
  const MERCHANT_STORAGE_KEY = "merchantname";
  const merchantname = Cookies.get(MERCHANT_STORAGE_KEY);
  const [note, setNote] = useState("");
  const pauselabel = Cookies.get("onlineOrderSettingsPauseLabel");
  const onlineDeliveryId = Cookies.get("onlineDeliveryId");
  // const isDelivery = Cookies.get("isDelivery");

  const [saveCard, setSaveCard] = useState(false);
  const [carddata, setCarddata] = useState<CardsData | null>(null);
  const userCustomer = Cookies.get("user");

  const [delivery, setDelivery] = useState(false);
  // const [formValue, setFormValue] = useState({});
  const [deliveryLink, setDeliveryLink] = useState("");

  // const [formData, setFormData] = useState({
  //   cardNumber: "",
  //   expirationDate: "",
  //   CVC: "",
  //   address1: "",
  //   address2: "",
  //   city: "",
  //   state: "",
  //   country: "",
  //   zip: "",
  //   nameOnCard: "", // Assuming you have a field for name on card
  // });

  // interface newCard {
  //   billingInfo: {
  //     firstName: string;
  //     lastName: string;
  //     address: string;
  //     city: string;
  //     state: string;
  //     zipCode: string;
  //     country: string;
  //     email: string;
  //     phone: string;
  //   };
  //   defaulitPaymentProfile: false;
  //   paymentInfo: {
  //     cardNumber: string;
  //     customerProfileId: string;
  //     exprDate: string;
  //     cardCode: string;
  //   };
  // }
  // const stateOption = useMemo(() => {
  //   return State.getAllStates()
  //     .filter((code: any) => code.countryCode === "US")
  //     .map((state: any) => ({
  //       label: state.name,
  //       value: state.isoCode,
  //     }));
  // }, []);
  const isDark = Cookies.get("theme");
  // const formatOptionLabel = ({ label, value }: any, { context }: any) => {
  //   return context === "value" ? value : label;
  // };
  const [user, setUser] = useState("");
  const [userdetail, setUserdetail] = useState("");
  const [lastName, setlastname] = useState("");
  const [useremail, setUseremail] = useState("");
  const [phonee, setPhone] = useState("");
  const [cards, setCards] = useState<CardData[]>([]);
  const [auth, setAuth] = useState<Card[]>([]);

  const customerAdded = Cookies.get("customerAdded");
  // console.log("customerAdded", customerAdded);
  const userDataString = Cookies.get("userDataaInfo");
  const SignupData = Cookies.get("SignupData");
  const PaymentId = Cookies.get("paymentId");

  // const userDataSignup = localStorage.getItem("userDataSignUp");
  const Info = Cookies.get("CustomerInfo");
  const [deliveryAddress, setDeliveryAddress] = useState<any>([]);
  const addedPayments = Cookies.get("addedPayments");

  const [onluyuth, setOnlyauth] = useState<any>([]);
  // const defaultCheckedCard = auth.slice(-1)[0];
  // const [billingCity, setBillingCity] = useState("");
  // const [billingAddressInfo, setBillingAddressInfo] = useState("");
  // const [billingZip, setBillingZip] = useState("");
  // const [billingState, setBillingState] = useState("");
  // const [billingCountry, setBillingCountry] = useState("");
  const isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
  // const handleSelect = (card: any) => {
  //   setSelectedCard(card);
  //   setShowCardField(false);
  // };

  useEffect(() => {
    // const existingCardsString = localStorage.getItem("newCard") || "[]";
    // setnewcardsdata (existingCardsString ? JSON.parse(existingCardsString) : []);
    const fetchDataFromApi = async () => {
      try {
        // Make the API call to fetch data
        if (userDataString && Info && !SignupData && !customerAdded) {
          console.log("testing");
          const response = JSON.parse(userDataString);
          const responsetwo = JSON.parse(Info);

          // Assuming the response is an object with a "Customer Info" property
          setlastname(responsetwo.lastName);

          setPhone(responsetwo.phone);
          setUserdetail(responsetwo.firstName);
          setUseremail(responsetwo.email);
          setUser(response.customerProfileId);
          if (addedPayments) {
            console.log("addedPayments: ", addedPayments);
            setAuth(JSON.parse(addedPayments));
          } else {
            setAuth(response.paymentProfiles);
          }
        } else if (
          userDataString &&
          customerAdded &&
          PaymentId === "undefined"
        ) {
          const response = JSON.parse(customerAdded);
          // const responsetwo = JSON.parse(userDataString);

          setUserdetail(response.firstName);
          setlastname(response.lastName);
          setUseremail(response.email);
          setPhone(response.phone);
          ////setUser(response.customerId);
        } else if (SignupData && PaymentId && customerAdded && userDataString) {
          const response = JSON.parse(SignupData);
          const responsethree = JSON.parse(customerAdded);
          const responsetwo = JSON.parse(userDataString);
          const responsefour = JSON.parse(PaymentId);

          setUserdetail(responsethree.firstName);
          setlastname(responsethree.lastName);
          setUseremail(responsethree.email);
          setPhone(responsethree.phone);
          setOnlyauth(responsefour.customerPaymentProfileId);
          const profileId =
            response.basilAuthNetProfileId ??
            responsetwo.customerProfileId ??
            userCustomer ??
            response.authNetProfileId;
          setUser(profileId ?? response.authNetProfileId);
          if (addedPayments) {
            setAuth(JSON.parse(addedPayments));
          } else {
            setAuth(
              responsetwo.paymentProfiles ??
              responsetwo["AuthNet Profile Info "]?.profile?.paymentProfiles
            );
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Call fetchDataFromApi if userData is not available in localStorage
    if (!user || !auth || !useremail || !useremail) {
      fetchDataFromApi();
    }
  }, [userDataString, customerAdded]);

  // },[auth])
  useEffect(() => {
    const storedOrderFe = Cookies.get("orderFee");
    const storedOrderFeeLabell = Cookies.get("orderFeeLabel");
    setStoredOrderFee(Number(storedOrderFe) || 0);
    setStoredOrderFeeLabel(storedOrderFeeLabell || "");

    if (auth) {
      const cardsData: {
        cardNumber: string;
        cardType: string;
        firstName: string;
        lastName: string;
        profileId: string;
        address: string;
        city: string;
        state: string;
        zip: string;
      }[] = auth.map((card) => ({
        cardNumber: card.payment.creditCard.cardNumber.replace(/\s/g, ""),
        cardType: card.payment.creditCard.cardType,
        firstName: card.billTo.firstName,
        lastName: card.billTo.lastName,
        profileId: card.customerPaymentProfileId,
        address: card.billTo.address,
        city: card.billTo.city,
        state: card.billTo.state,
        zip: card.billTo.zip,
      }));

      setCards(cardsData);
    }
  }, [auth]);
  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };
  // const handleAddCard = () => {
  //   // Add logic to handle adding a new card here
  //   setSelectedCard(null);
  //   setShowCardField(true);
  // };
  useEffect(() => {
    // const AddressData = JSON.parse(localStorage.getItem("userData") as any);

    Cookies.set(
      "BillingAddress",
      (JSON.stringify(selectedCard?.billTo) as any) || null
    );
  }, [selectedCard]);

  const getCurrentTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  };
  // const handleSaveCard = async (data: any) => {
  //   if (saveCard === true) {
  //     setSaveCard(false);
  //   } else {
  //     setSaveCard(true);
  //   }
  //   setCarddata(data);
  //   setSelectedCard(null);
  // };
  const hadlepickUpTime = (value: any) => {
    setPickUpTime(value);
  };
  const handleNoteChange = (event: any) => {
    setNote(event.target.value);
  };

  // const handlePickupTimeChange = (event: any) => {
  //   setPickupTime(event.target.value);
  //   setIsAsap(false);
  //   setSelectedTime(true);
  // };
  // const optionDelivery = (value: any) => {
  //   if (value === "delivery") {
  //     setDelivery(true);
  //   } else {
  //     setDelivery(false);
  //   }
  // };

  const saveDelivery = async (data: any, value: any) => {
    // const data = (this as any).data;
    // setQuotes(true);
    setIsQuotesProcessing(true);
    const baseurl = appConfig.apiPrefix;
    if (value === true) {
      const id = onlineDeliveryId;

      if (id && delivery === true) {
        const newData = {
          merchant_id: id,
          dropoff_street: data?.delivery?.address1,
          dropoff_city: data?.delivery?.city,
          dropoff_state: data?.delivery?.state,
          dropoff_zip: data?.delivery?.zip,
          dropoff_country: data?.delivery?.country,
          dropoff_suite: data?.delivery?.address2,
          dropoff_instructions: data?.delivery?.deliveryInstructions,
        };
        const newerData = {
          merchant_id: id,
          dropoff_street: data?.delivery?.address1,
          dropoff_city: data?.delivery?.city,
          dropoff_state: data?.delivery?.state,
          dropoff_zip: data?.delivery?.zip,
          dropoff_country: data?.delivery?.country,
          dropoff_suite: data?.delivery?.address2,
          dropoff_instructions: data?.delivery?.deliveryInstructions,
          customer_name: data?.delivery?.deliverTo,
          customer_phone: data?.delivery?.contact,
        };
        console.log("newData", newerData);
        let responseMerchant: AxiosResponse<MyResponseData, any>;

        const apiurlmerchant = "/kitchenHub/delivery/quotes";
        responseMerchant = await axios.post(baseurl + apiurlmerchant, newData, {
          headers: {
            MID: merchantname,
            Timezone: getCurrentTimezone(),
            Authorization: "1iIfU6btjHW85C6HvCIG5NGfU06evEck",
          },
        });
        setDeliveryAddress(newerData);

        if (responseMerchant?.data?.Body !== "[]\n") {
          handleResponse(responseMerchant.data);
          setNoQuotes(false);
        } else {
          setNoQuotes(true);
        }
        setIsQuotesProcessing(false);
        //  setQuotes(true);
      }
    }
  };

  // const handleAsapChange = () => {
  //   setIsAsap(true);
  //   setPickupTime("asap");
  //   setSelectedTime(false);
  // };

  const handleTipSelection = (tip: any) => {
    setSelectedTip(tip);
  };
  const handleDeliveryTipSelection = (tip: any) => {
    setSelectedDeliveryTip(tip);
  };

  const handleCustomTipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;

    // Remove any non-numeric characters
    const numericValue = value.replace(/[^0-9]/g, "");

    // Convert the numeric value to the decimal format
    if (numericValue) {
      const formattedValue = (parseInt(numericValue, 10) / 100).toFixed(2);

      setCustomTip(formattedValue);
      setErrorMessage("");
    } else {
      setCustomTip("0.00");
      setErrorMessage("Invalid tip. Please enter a positive value.");
    }
  };

  const timeOptions: string[] = [];
  for (let hour = 9; hour <= 21; hour++) {
    const time = `${hour % 12 || 12} ${hour < 12 ? "AM" : "PM"}`;
    timeOptions.push(time);
  }

  const TaxDetails = (item: Product) => {
    const { taxes } = item;
    const taxDetails: Record<string, { rate: number; type: string }> = {};
    if (taxes) {
      taxes.forEach((tax) => {
        if (taxDetails[tax.name]) {
          if (taxDetails[tax.name].type === tax.type) {
            taxDetails[tax.name].rate += tax.rate;
          }
        } else {
          taxDetails[tax.name] = { rate: tax.rate, type: tax.type };
        }
      });
    }
    return taxDetails;
  };

  const taxDetails = Products.reduce(
    (
      accumulator: Record<string, { rate: number; type: string }>,
      product: Product
    ) => {
      const details = TaxDetails(product);
      Object.entries(details).forEach(([name, { rate, type }]) => {
        if (accumulator[name]) {
          if (accumulator[name].type === type) {
            accumulator[name].rate = rate;
          }
        } else {
          accumulator[name] = { rate, type };
        }
      });
      return accumulator;
    },
    {}
  );

  const reorderTaxDetails = reOrderData?.orderItems?.reduce(
    (
      accumulator: Record<string, { rate: number; type: string }>,
      product: any
    ) => {
      const details = TaxDetails(product.item);
      Object.entries(details).forEach(([name, { rate, type }]) => {
        if (accumulator[name]) {
          if (accumulator[name].type === type) {
            accumulator[name].rate = rate;
          }
        } else {
          accumulator[name] = { rate, type };
        }
      });
      return accumulator;
    },
    {}
  );

  const mergedTaxDetails = { ...taxDetails };
  if (location.state && reorderTaxDetails) {
    Object.entries(reorderTaxDetails).forEach(([name, { rate, type }]: any) => {
      if (mergedTaxDetails[name]) {
        if (mergedTaxDetails[name].type === type) {
          mergedTaxDetails[name].rate = rate;
        }
      } else {
        mergedTaxDetails[name] = { rate, type };
      }
    });
  }

  interface TaxTotal {
    name: string;
    rate: number;
    amount: number;
  }

  const togglePopup = () => {
    setIsPopupVisible(!isPopupVisible);
    if (responseData !== null) {
      window.location.href = `/${merchantname}`;
      localStorage.removeItem("orderCards");
    }
  };

  const TaxName = (item: Product) => {
    const { onlinePrice, quantity, modifierChecked, modifierSets, taxes } =
      item;
    let basePrice = quantity ? 1 * quantity : onlinePrice;
    let taxAmt = 0;
    const taxname: string[] = [];
    if (taxes) {
      taxes.forEach((taxes) => {
        taxname.push(taxes.name);
      });
    }
    return taxname;
  };

  interface TaxTotal {
    name: string;
    rate: number;
    amount: number;
  }

  const calculatingTotalTax = (item: any): TaxTotal[] => {
    let taxTotalses: TaxTotal[] = [];
    if (item.item) {
      let quant = item.quantity ? item.quantity : 1;
      if (location.state) {
        const totalPrice: number = parseFloat(calculatingNewTotalPrice(item));
        if (item.item?.taxes) {
          item.item.taxes.forEach((tax: any) => {
            let totTaxAmt = 0;
            if (tax.type === "Percentage") {
              totTaxAmt = totalPrice * (tax.rate / 100);
            } else {
              totTaxAmt = quant * tax.rate;
            }
            taxTotalses.push({
              name: tax.name,
              rate: tax.rate,
              amount: totTaxAmt,
            });
          });
        }
      }
    } else {
      const { quantity, onlinePrice, taxes } = item;
      if (taxes) {
        let basePrice = quantity ? 1 * quantity : onlinePrice;
        taxes.forEach((tax: any) => {
          let totTaxAmt = 0;
          if (tax.type === "Percentage") {
            totTaxAmt = calculatingTotalPrice(item) * (tax.rate / 100);
          } else {
            totTaxAmt = basePrice * tax.rate;
          }
          taxTotalses.push({
            name: tax.name,
            rate: tax.rate,
            amount: totTaxAmt,
          });
        });
      }
    }
    return taxTotalses;
  };

  const calTip = (selectedTip: any) => {
    let totalTip;
    if (selectedTip === "none") {
      totalTip = 0;
    } else {
      totalTip = parseFloat(selectedTip.replace("%,")) / 100;
    }
    const TipReturn = totalTip;
    return TipReturn;
  };
  const calDeliveryTip = (selectedDeliveryTip: any) => {
    let totalTip;
    if (selectedDeliveryTip === "none") {
      totalTip = 0;
    } else {
      totalTip = parseFloat(selectedDeliveryTip.replace("%,")) / 100;
    }
    const TipReturn = totalTip;
    return TipReturn;
  };
  const calculatingTotalPrice = (item: Product) => {
    const { onlinePrice, quantity, modifierChecked, modifierSets } = item;
    let allPrice = onlinePrice;

    if (modifierSets) {
      modifierSets.forEach((modifierSets) => {
        const matchingKey =
          modifierChecked &&
          Object.keys(modifierChecked)?.find(
            (key) => Number(key) === modifierSets.id
          );
        if (matchingKey) {
          modifierSets.modifierSetModifierItems?.forEach((modifierItem) => {
            const modifierItemId = modifierItem.id.toString();
            if (modifierChecked[matchingKey]?.[modifierItemId] !== undefined) {
              allPrice += modifierChecked[matchingKey][modifierItemId]
                ? modifierItem.modifierItem.onlinePrice
                : 0;
            }
          });
        }
      });
    }
    let basePrice = quantity ? allPrice * quantity : allPrice;
    return basePrice;
  };

  const calculatingNewTotalPrice = (item: any) => {
    const { quantity, item: itemDetails, orderItemModifiers } = item;
    let totalPrice = itemDetails.onlinePrice * quantity;
    if (orderItemModifiers && orderItemModifiers.length > 0) {
      const modifiersPrice = orderItemModifiers.reduce(
        (acc: any, modifier: any) => {
          return acc + modifier.modifierItem.onlinePrice * quantity;
        },
        0
      );
      totalPrice += modifiersPrice;
    }
    return totalPrice.toFixed(2);
  };
  const OnlytaxTotals: TaxTotal[] = Products.flatMap((product: any) =>
    calculatingTotalTax(product)
  );
  const reorderTaxTotals: TaxTotal[] =
    reOrderData?.orderItems?.flatMap((product: any) =>
      calculatingTotalTax(product)
    ) || [];

  let taxTotals: TaxTotal[] = [];
  if (OnlytaxTotals.length > 0 || reorderTaxTotals.length > 0) {
    if (OnlytaxTotals.length > 0) {
      taxTotals = [...OnlytaxTotals];
    } else if (reorderTaxTotals.length > 0) {
      taxTotals = [...reorderTaxTotals];
    }
  }

  const taxDisplayTotal = Object.values(
    taxTotals.reduce((accumulator: Record<string, number>, taxTotal) => {
      const { name, amount } = taxTotal;
      accumulator[name] = (accumulator[name] || 0) + amount;
      return accumulator;
    }, {})
  ).map((totalAmount: number) => totalAmount.toFixed(2));
  const seenTypes = new Set<string>();

  const taxDisplayList: string[] = [];

  taxTotals.forEach(({ name, rate }) => {
    if (!seenTypes.has(name)) {
      // Track by tax name instead of type
      seenTypes.add(name);
      const { type } = mergedTaxDetails[name];
      if (type === "Percentage") {
        taxDisplayList.push(`${name}: ${rate}%`);
      } else if (type === "Fixed") {
        taxDisplayList.push(`${name}: $${rate}`);
      } else {
        taxDisplayList.push(`${name}: ${rate}`); // Fallback in case of an unexpected type
      }
    }
  });
  console.log("taxTotals", taxTotals, taxDisplayList, mergedTaxDetails);

  const selectedModifierItems = (item: Product) => {
    let selectedModifierItemIds: number[] = [];
    const { onlinePrice, quantity, modifierChecked, modifierSets, note } = item;
    if (modifierSets) {
      modifierSets.forEach((modifierSets) => {
        const matchingKey =
          modifierChecked &&
          Object.keys(modifierChecked)?.find(
            (key) => Number(key) === modifierSets.id
          );
        if (matchingKey) {
          modifierSets.modifierSetModifierItems?.forEach((modifierItem) => {
            const modifierItemId = modifierItem.id.toString();
            if (modifierChecked[matchingKey]?.[modifierItemId] !== undefined) {
              selectedModifierItemIds.push(modifierItem.modifierItem.id);
            }
          });
        }
      });
    }
    return selectedModifierItemIds;
  };

  // const validateCardNumber = (values: any) => {
  //   const cardNumber = values.replace(/\s/g, ""); // Remove all spaces

  //   if (!cardNumber) {
  //     return "Card number is required";
  //   } else if (cardNumber.length < 13) {
  //     return "Card number must be at least 13 digits";
  //   } else if (cardNumber.length > 16) {
  //     return "Card number must be no more than 16 digits";
  //   } else {
  //     return true;
  //   }
  // };

  // const validateData = (value: any) => {
  //   if (!/^\d{2}\/\d{2}$/.test(value)) {
  //     return "Expiration date must be in MM/YY format";
  //   }
  //   const [month, year] = value.split("/").map(Number);
  //   if (month < 1 || month > 12) {
  //     return "Expiration month must be between 01 and 12";
  //   }

  //   const currentYear = new Date().getFullYear() % 100;
  //   const currentMonth = new Date().getMonth() + 1;

  //   if (year < currentYear || (year === currentYear && month < currentMonth)) {
  //     return "Invalid Expiration date";
  //   } else {
  //     return true;
  //   }
  // };

  const methods = useForm({
    defaultValues: {
      delivery: {
        deliverTo: "",
        contact: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "USA",
        zip: "",
        deliveryInstructions: "",
      },

      cardNumber: "",
      firstname: "",
      lastname: "",
      expirationDate: "",
      CVC: "",
      payment: {
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "USA ",
        zip: "",
      },
    },
  });
  const {
    control,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = methods;

  const cleanPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber) {
      return phoneNumber.replace(/\D/g, "");
    } else {
      return null;
    }
  };

  const [deliveryOptions, setDeliveryOptions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [quoteId, setQuoteId] = useState("");
  const [quoteProvider, setQuoteProvider] = useState("");
  const [deliveryFee, setDeliveryFee] = useState("");
  const [estimatedTime, setEstimatedTime] = useState(0);
  const [pickUp, setPickUp] = useState(0);
  const [noQuotes, setNoQuotes] = useState(false);
  const handleResponse = (response: any) => {
    const parsedData = JSON.parse(response.Body);
    setDeliveryOptions(parsedData);
    setIsPopupVisible(!isPopupVisible);
    setIsModalOpen(true); // Open the modal
  };
  const hasFetchedRef = useRef(false);
  useEffect(() => {
    const fetchCustomerProfile = async () => {
      try {
        if (!userCustomer || userCustomer === null || hasFetchedRef.current)
          return;
        hasFetchedRef.current = true; // Mark as fetched
        const apiurlone = `/onlineOrder/customer`;
        let responseAdded: AxiosResponse<any, any>;
        const baseurl = appConfig.apiPrefix;
        responseAdded = await axios.get(baseurl + apiurlone, {
          headers: {
            MID: merchantname,
            timeZone: getCurrentTimezone(),
          },
          params: {
            customerProfileId: String(userCustomer ?? "").replace(/\D/g, ""), // Query parameter
          },
        });

        if (responseAdded?.data) {
          if (responseAdded.data?.customerProfileId) {
            Cookies.set("user", responseAdded.data.customerProfileId);
            setUser(responseAdded.data.customerProfileId);
          }
          // Kanopy: build auth array from "Kanopy Card Info"
          if (isKanopyGateway()) {
            const kanopyInfo = responseAdded.data?.["Kanopy Card Info"];
            if (kanopyInfo?.hasSavedCard) {
              setAuth([{
                payment: { creditCard: {
                  cardNumber: `xxxx${kanopyInfo.cardLast4 ?? ""}`,
                  cardType: kanopyInfo.cardType ?? "",
                  expirationDate: "",
                }},
                billTo: { customerId: "", firstName: "", lastName: "", profileId: "",
                  address: "", city: "", state: "", zip: "" },
                customerPaymentProfileId: "",
              }]);
            }
          } else if (responseAdded.data?.paymentProfiles) {
            setAuth(responseAdded.data.paymentProfiles);
          }
        }
      } catch (error) {
        console.error("Error fetching customer profile:", error);
      }
    };
    fetchCustomerProfile();
  }, [userCustomer]);

  // const formatPickupTime = (pickupTime: any) => {
  //   const [datePart, timePart] = pickupTime.split(" ");
  //   const [day, month, year] = datePart.split("-");
  //   const [hours, minutes] = timePart.split(":");

  //   const date = new Date(year, month - 1, day, hours, minutes);

  //   const options = {
  //     hour: "numeric",
  //     minute: "numeric",
  //     hour12: true,
  //   } as const;

  //   return datePart + " " + date.toLocaleString("en-US", options);
  // };
  const submitOrder = async (data: any) => {
    console.log("data", data);
    await setGreenFlag(false);
    if (delivery === false) {
      setIsPaymentProcessing(true);
    } else if (delivery === true && confirmDialog === true) {
      setIsPaymentProcessing(true);
      await setConfirmDialog(false);
    } else if (delivery === true && confirmDialog === false) {
      setConfirmDialog(true);
      return;
    }

    if (Products.length === 0 && reOrderData.orderItems.length === 0) {
      console.log("check for testing");
      setCartError(
        "Your cart is empty. Please add items to the cart before submitting the order."
      );
      return;
    } else {
      setCartError("");
    }
    const pauseOrder = Cookies.get("pause");
    setPause(pauseOrder as any);
    const historyOrderSubmit = historyOrders?.map((item: any) => ({
      itemId: item.item.id,
      price: item.price,
      quantity: item.quantity,
      note: item.note,
      modifierSetItemsList: item.orderItemModifiers.map(
        (modifier: any) => modifier.modifierItem.id
      ),
    }));

    const ProductOrder = Products.map((eachItem: any) => ({
      itemId: eachItem.id,
      modifierSetItemsList: selectedModifierItems(eachItem),
      price: eachItem.onlinePrice,
      quantity: eachItem.quantity,
      note: eachItem.note,
    }));
    const allProductOrder = [
      ...ProductOrder,
      ...(historyOrders?.length > 0 ? historyOrderSubmit : []),
    ];

    try {
      setSomethingWrong(false);
      let orderData:any;
      if (auth.length && SignupData && selectedCard) {
        orderData = {
          // For Kanopy, backend ignores authNet and looks up saved card by email in basilOrder.customerInfo
          authNet: isKanopyGateway() ? {} : {
            customerProfileId: user,
            paymentProfileId: selectedCard.customerPaymentProfileId,
          },
          basilOrder: {
            customerInfo: {
              firstName: userdetail,
              lastName: lastName,
              email: useremail,
              phone: cleanPhoneNumber(phonee),
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      } else if (auth.length && userDataString && selectedCard) {
        console.log(auth.length, userDataString, selectedCard);
        orderData = {
          authNet: isKanopyGateway() ? {} : {
            customerProfileId: user,
            paymentProfileId: selectedCard.customerPaymentProfileId,
          },
          basilOrder: {
            customerInfo: {
              firstName: userdetail,
              lastName: lastName,
              email: useremail,
              phone: cleanPhoneNumber(phonee),
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      } else if (!selectedCard && saveCard && carddata && userDataString) {
        orderData = {
          authNet: {
            cardNumber: carddata.cardNumber.replace(/\s/g, ""),
            exprDate: carddata.expirationDate,
            cardCode: carddata.CVC,
            customerProfileId: user,
            defaultPaymentProfile: false,
            billingInfo: {
              firstName: carddata.firstname,
              lastName: carddata.lastname,

              address:
                carddata?.payment?.address1 + " " + carddata?.payment.address2,
              city: carddata.payment.city,
              state: carddata.payment.state,
              country: carddata.payment.country,
              addressType: "Billing",
              zipCode: carddata.payment.zip,
            },
          },
          basilOrder: {
            customerInfo: {
              firstName: userdetail,
              lastName: lastName,
              email: useremail,
              phone: cleanPhoneNumber(phonee),
              // address:
              //   carddata?.payment?.address1 + " " + carddata?.payment.address2,
              // city: carddata.payment.city,
              // state: carddata.payment.state,
              // country: carddata.payment.country,
              // addressType: "Billing",
              // zipCode: carddata.payment.zip,
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      } else if (!selectedCard && saveCard === false && userDataString) {
        orderData = {
          authNet: {
            cardNumber: data.cardNumber.replace(/\s/g, ""),
            exprDate: data.expirationDate,
            cardCode: data.CVC,
            customerProfileId: user,
            defaultPaymentProfile: false,
            billingInfo: {
              firstName: data.firstname,
              lastName: data.lastname,

              address: data.payment.address1 + " " + data.payment.address2,
              city: data.payment.city,
              state: data.payment.state,
              country: data.payment.country,
              addressType: "Billing",
              zipCode: data.payment.zip,
            },
          },
          basilOrder: {
            customerInfo: {
              firstName: userdetail,
              lastName: lastName,
              email: useremail,
              phone: cleanPhoneNumber(phonee),
              // address: data.payment.address1 + " " + data.payment.address2,
              // city: data.payment.city,
              // state: data.payment.state,
              // country: data.payment.country,
              // addressType: "Billing",
              // zipCode: data.payment.zip,
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      } else if (!auth.length && userDataString) {
        orderData = {
          authNet: {
            cardNumber: data.cardNumber.replace(/\s/g, ""),
            exprDate: data.expirationDate,
            cardCode: data.CVC,
            customerProfileId: "",
            defaultPaymentProfile: false,
            billingInfo: {
              firstName: data.firstname,
              lastName: data.lastname,
              address: data.payment.address1,
              city: data.payment.city,
              state: data.payment.state,
              country: data.payment.country,
              addressType: "Billing",
              zipCode: data.payment.zip,
            },
          },
          basilOrder: {
            customerInfo: {
              firstName: userdetail,
              lastName: lastName,
              email: useremail,
              phone: cleanPhoneNumber(phonee),
              // address: data.payment.address1,
              // city: data.payment.city,
              // state: data.payment.state,
              // country: data.payment.country,
              // addressType: "Billing",
              // zipCode: data.payment.zip,
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      } else if (!auth.length && SignupData) {
        orderData = {
          authNet: {
            cardNumber: data.cardNumber.replace(/\s/g, ""),
            exprDate: data.expirationDate,
            cardCode: data.CVC,
            customerProfileId: "",
            defaultPaymentProfile: false,
            billingInfo: {
              firstName: data.firstname,
              lastName: data.lastname,
              address: data.payment.address1,
              city: data.payment.city,
              state: data.payment.state,
              country: data.payment.country,
              addressType: "Billing",
              zipCode: data.payment.zip,
            },
          },
          basilOrder: {
            customerInfo: {
              firstName: userdetail,
              lastName: lastName,
              email: useremail,
              phone: cleanPhoneNumber(phonee),
              // address: data.payment.address1,
              // city: data.payment.city,
              // state: data.payment.state,
              // country: data.payment.country,
              // addressType: "Billing",
              // zipCode: data.payment.zip,
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      } else {
        orderData = {
          authNet: {
            cardNumber: data.cardNumber.replace(/\s/g, ""),
            exprDate: data.expirationDate,
            cardCode: data.CVC,
            customerProfileId: "",
            defaultPaymentProfile: false,
            billingInfo: {
              firstName: data.firstname,
              lastName: data.lastname,
              address: data.payment.address1,
              city: data.payment.city,
              state: data.payment.state,
              country: data.payment.country,
              addressType: "Billing",
              zipCode: data.payment.zip,
            },
          },
          basilOrder: {
            customerInfo: {
              firstName: firstname,
              lastName: lastname,
              email: email,
              phone: cleanPhoneNumber(phoneNumber),
              // address: data.payment.address1,
              // city: data.payment.city,
              // state: data.payment.state,
              // country: data.payment.country,
              // addressType: "Billing",
              // zipCode: data.payment.zip,
            },
            orderItemList: allProductOrder,
            pickUpTime: delivery ? "" : pickUpTime,
            status: "pending",
            subTotal: subTotal.toFixed(2),
            tip: selectedTip ? finalTip(selectedTip) : 0.0,
            type: "online",
            discount: 0,
            note: note,
          },
        };
      }
      let orderDataUpdated :any;

      if (delivery === true) {
        orderDataUpdated = {
          kitchenHub: {
            driver_tip: selectedDeliveryTip
              ? Math.round(finalDeliveryTip(selectedDeliveryTip) * 100)
              : 0,
            deliveryFee: Number(deliveryFee),
          },
          authNet: {
            ...orderData.authNet,
          },
          basilOrder: {
            ...orderData.basilOrder,
          },
        };
      } else if (delivery === false) {
        orderDataUpdated = {
          authNet: {
            ...orderData.authNet,
          },

          basilOrder: {
            ...orderData.basilOrder,
          },
        };
      } else {
        orderDataUpdated = {
          authNet: { ...orderData.authNet },
          basilOrder: { ...orderData.basilOrder },
        };
      }

      const apiUrl = `/onlineOrder/payment/customer`;
      // New card (no payment profile): use /payment/nonce for both pickup and delivery. Saved card: use /payment/customer or /payment.
      const isNewCardPayment =
        (!userDataString && !SignupData) ||
        (!selectedCard && (userDataString || SignupData));
      const apiurlone = isNewCardPayment
        ? `/onlineOrder/payment/nonce`
        : selectedCard
          ? apiUrl
          : `/onlineOrder/payment`;
      const header = getHeaders();
      const baseurl = appConfig.apiPrefix;

      if (isNewCardPayment) {
        // ── KANOPY PATH ──────────────────────────────────────────────────────
        if (isKanopyGateway()) {
          const merchantDeviceGuid = getKanopyDeviceGuid();
          const merchantApiKey = getKanopyApiKey();
          const basilDeviceGuid = getBasilKanopyDeviceGuid();
          const basilApiKey = getBasilKanopyApiKey();

          let kanopyPayload: Record<string, unknown>;
          try {
            if (delivery || saveCard) {
              // Dual tokenization: merchant + Basil
              const { merchantToken, basilToken } = await tokenizeForDelivery(
                merchantDeviceGuid, basilDeviceGuid, merchantApiKey, basilApiKey
              );
              kanopyPayload = {
                merchantToken: merchantToken.token,
                merchantCardType: merchantToken.cardType,
                merchantLast4: merchantToken.last4,
                basilToken: basilToken.token,
              };
            } else {
              // Single tokenization: pickup, no save — Token.js handles it browser-side
              const tokenData = await triggerKanopyTokenization();
              kanopyPayload = {
                merchantToken: tokenData.token,
                merchantCardType: tokenData.cardType,
                merchantLast4: tokenData.last4,
              };
            }
          } catch (err: any) {
            setAuthNet(err?.message ?? "Payment tokenization failed. Please check your card details.");
            setIsPaymentProcessing(false);
            setIsPopupVisible(!isPopupVisible);
            return;
          }

          const finalPayload = { ...orderDataUpdated, kanopyToken: kanopyPayload };
          const headers = !userDataString && !SignupData
            ? { cardSave: saveCard, isDelivery: delivery ? "True" : "False", MID: merchantname, timeZone: getCurrentTimezone() }
            : { cardSave: saveCard, isDelivery: delivery ? "True" : "False", MID: merchantname, Timezone: getCurrentTimezone() };

          try {
            const res = await axios.post(appConfig.apiPrefix + apiurlone, finalPayload, { headers });
            const message = (res.data as Record<string, unknown>) ?? {};

            // Parse response — Kanopy uses saleGuid; also handle transId for backward compat
            const checkoutBody = !delivery ? message : (message?.checkoutResponse as Record<string, unknown>);
            const saleGuid = (checkoutBody?.saleGuid ?? checkoutBody?.transId) as string | undefined;
            const feesBody = message?.tipsAndFeesResponse as Record<string, unknown> | undefined;
            const feesSaleGuid = (feesBody?.saleGuid ?? feesBody?.transId) as string | undefined;
            const checkoutSuccess = checkoutBody?.success === true;
            const feesSuccess = !delivery || feesBody?.success === true;

            if (delivery && (!checkoutSuccess || !feesSuccess)) {
              setAuthNet("Payment could not be completed. Please try again.");
              setIsPaymentProcessing(false);
              setIsPopupVisible(!isPopupVisible);
              return;
            }

            if (checkoutSuccess || (!delivery && saleGuid && saleGuid !== "0")) {
              setGreenFlag(true);
              setIsPopupVisible(!isPopupVisible);
              setAuthNet("This transaction has been approved.");

              // Delivery capture step
              if (delivery && checkoutSuccess && feesSuccess && saleGuid && feesSaleGuid && quoteId) {
                const bo = orderDataUpdated?.basilOrder ?? {};
                const deliveryOrderPayload = {
                  kitchenHub: {
                    deliveryFee: Math.round((Number(deliveryFee) || 0) * 100),
                    driver_tip: selectedDeliveryTip ? Math.round(finalDeliveryTip(selectedDeliveryTip) * 100) : 0,
                    quote_id: quoteId,
                    customer_name: data?.delivery?.deliverTo ?? "",
                  },
                  basilOrder: {
                    transId: saleGuid,
                    basilTransId: feesSaleGuid,
                    customerInfo: {
                      firstName: bo.customerInfo?.firstName ?? "",
                      lastName: bo.customerInfo?.lastName ?? "",
                      email: bo.customerInfo?.email ?? "",
                      phone: bo.customerInfo?.phone ?? "",
                      address_label: "Delivery",
                      dropoff_street: data?.delivery?.address1 ?? "",
                      dropoff_city: data?.delivery?.city ?? "",
                      dropoff_state: data?.delivery?.state ?? "",
                      dropoff_zip: data?.delivery?.zip ?? "",
                      dropoff_country: data?.delivery?.country ?? "USA",
                      address: "Delivery",
                    },
                    orderItemList: bo.orderItemList ?? [],
                    pickUpTime: bo.pickUpTime ?? "",
                    status: bo.status ?? "pending",
                    subTotal: bo.subTotal ?? String(subTotal.toFixed(2)),
                    tip: bo.tip ?? 0,
                    type: bo.type ?? "online",
                    discount: bo.discount ?? 0,
                    note: bo.note ?? "",
                  },
                };
                try {
                  const orderRes = await axios.post(
                    appConfig.apiPrefix + "/kitchenHub/delivery/test/orders",
                    deliveryOrderPayload,
                    { headers: { MID: merchantname, isDelivery: "True", Timezone: getCurrentTimezone() } }
                  );
                  const resData = orderRes?.data ?? {};
                  const linkResponse = (resData as any)["Delivery Tracker Link"];
                  if (linkResponse) setDeliveryLink(linkResponse);
                  const orderNo = (resData as any)?.orderNo ?? (resData as any)?.checkoutResponse?.orderNo;
                  if (orderNo != null) setResponseData({ orderNo });
                } catch (err: any) {
                  setAuthNet(err?.message ?? "Delivery order could not be placed. Please contact support.");
                  setSomethingWrong(true);
                }
              } else {
                const orderNo = (message as any)?.orderNo ?? (message as any)?.checkoutResponse?.orderNo;
                if (orderNo != null) setResponseData({ orderNo });
              }
            } else {
              setAuthNet("Issue authorizing payment. Please check the card details and try again.");
            }
          } catch (err: any) {
            setAuthNet(err?.message ?? "Payment failed. Please try again.");
            setSomethingWrong(true);
          }
          setIsPaymentProcessing(false);
          setIsPopupVisible(!isPopupVisible);
          return;
        }
        // ── END KANOPY PATH ──────────────────────────────────────────────────

        const hasCardData =
          data &&
          String(data.cardNumber ?? "").replace(/\s/g, "").length >= 13 &&
          String(data.expirationDate ?? "").trim() !== "";
        if (!hasCardData) {
          setAuthNet("Please enter card number and expiration before confirming.");
          setIsPaymentProcessing(false);
          setIsPopupVisible(!isPopupVisible);
          return;
        }
        loadAcceptJs()
          .then(() => {
            if (typeof window.Accept === "undefined") {
              setAuthNet(
                "Payment script did not load. Allow https://jstest.authorize.net in Content-Security-Policy (dev server/CDN)."
              );
              setIsPaymentProcessing(false);
              setIsPopupVisible(!isPopupVisible);
              return;
            }
            const { month: expMonth, year: expYear } = parseExpiration(
              data.expirationDate || ""
            );
            return tokenizeCardWithAcceptJs(
          String(data.cardNumber || ""),
          expMonth,
          expYear,
          String(data.CVC || "")
        )
          .then((merchantOpaqueData) => {
            if (import.meta?.env?.DEV) {
              console.log("Auth.net merchant nonce:", merchantOpaqueData.dataValue);
            }
            // Delivery: call Accept.js twice – second call always uses prod URL (https://js.authorize.net/v1/Accept.js)
            if (delivery) {
              return loadAcceptJs({ useProdUrl: true }).then(() =>
                tokenizeCardWithAcceptJsWithCredentials(
                  String(data.cardNumber || ""),
                  expMonth,
                  expYear,
                  String(data.CVC || ""),
                  getBasilCredentials()
                )
              ).then((basilOpaqueData) => {
                const authNetPayload: Record<string, unknown> = {
                  billingInfo: orderData.authNet?.billingInfo ?? {},
                  merchantDataDescriptor: merchantOpaqueData.dataDescriptor,
                  merchantDataValue: merchantOpaqueData.dataValue,
                  basilDataDescriptor: basilOpaqueData.dataDescriptor,
                  basilDataValue: basilOpaqueData.dataValue,
                };
                return {
                  payload: {
                    ...orderDataUpdated,
                    authNet: authNetPayload,
                  } as Record<string, unknown>,
                };
              });
            }
            // Pickup + save card: call Accept.js twice – second call always uses prod URL (https://js.authorize.net/v1/Accept.js)
            if (saveCard) {
              return loadAcceptJs({ useProdUrl: true }).then(() =>
                tokenizeCardWithAcceptJsWithCredentials(
                  String(data.cardNumber || ""),
                  expMonth,
                  expYear,
                  String(data.CVC || ""),
                  getBasilCredentials()
                )
              ).then((basilOpaqueData) => {
                const authNetPayload: Record<string, unknown> = {
                  billingInfo: orderData.authNet?.billingInfo ?? {},
                  // dataDescriptor: merchantOpaqueData.dataDescriptor,
                  // dataValue: merchantOpaqueData.dataValue,
                  merchantDataDescriptor: merchantOpaqueData.dataDescriptor,
                  merchantDataValue: merchantOpaqueData.dataValue,
                  basilDataDescriptor: basilOpaqueData.dataDescriptor,
                  basilDataValue: basilOpaqueData.dataValue,
                };
                if (orderData.authNet?.customerProfileId != null && String(orderData.authNet.customerProfileId).trim() !== "") {
                  authNetPayload.customerProfileId = orderData.authNet.customerProfileId;
                }
                if (orderData.authNet?.defaultPaymentProfile !== undefined) {
                  authNetPayload.defaultPaymentProfile = orderData.authNet.defaultPaymentProfile;
                }
                return {
                  payload: {
                    ...orderDataUpdated,
                    authNet: authNetPayload,
                  } as Record<string, unknown>,
                };
              });
            }
            // Pickup, don't save card: single nonce in dataDescriptor / dataValue
            const authNetPayload: Record<string, unknown> = {
              billingInfo: orderData.authNet?.billingInfo ?? {},
              dataDescriptor: merchantOpaqueData.dataDescriptor,
              dataValue: merchantOpaqueData.dataValue,
            };
            if (orderData.authNet?.customerProfileId != null && String(orderData.authNet.customerProfileId).trim() !== "") {
              authNetPayload.customerProfileId = orderData.authNet.customerProfileId;
            }
            if (orderData.authNet?.defaultPaymentProfile !== undefined) {
              authNetPayload.defaultPaymentProfile = orderData.authNet.defaultPaymentProfile;
            }
            return Promise.resolve({
              payload: {
                ...orderDataUpdated,
                authNet: authNetPayload,
              } as Record<string, unknown>,
            });
          })
          .then(({ payload }) => {
            const authNet = payload.authNet as Record<string, unknown> | undefined;
            if (!authNet) {
              setAuthNet("Payment data invalid.");
              setIsPaymentProcessing(false);
              setIsPopupVisible(!isPopupVisible);
              return Promise.reject(new Error("Invalid authNet"));
            }
            if (delivery) {
              const hasMerchant =
                typeof authNet.merchantDataDescriptor === "string" && (authNet.merchantDataDescriptor as string).trim() !== "" &&
                typeof authNet.merchantDataValue === "string" && (authNet.merchantDataValue as string).trim() !== "";
              const hasBasil =
                typeof authNet.basilDataDescriptor === "string" && (authNet.basilDataDescriptor as string).trim() !== "" &&
                typeof authNet.basilDataValue === "string" && (authNet.basilDataValue as string).trim() !== "";
              if (!hasMerchant) {
                setAuthNet("Merchant payment token invalid. Missing merchantDataDescriptor or merchantDataValue.");
                setIsPaymentProcessing(false);
                setIsPopupVisible(!isPopupVisible);
                return Promise.reject(new Error("Invalid merchant nonce"));
              }
              if (!hasBasil) {
                setAuthNet("Basil payment token invalid. Delivery fees and tips could not be authorized.");
                setIsPaymentProcessing(false);
                setIsPopupVisible(!isPopupVisible);
                return Promise.reject(new Error("Invalid basil nonce"));
              }
            } else {
              // Pickup with saveCard uses merchantDataDescriptor/Value + basilDataDescriptor/Value
              const hasDualTokens =
                typeof authNet.merchantDataDescriptor === "string" && (authNet.merchantDataDescriptor as string).trim() !== "" &&
                typeof authNet.merchantDataValue === "string" && (authNet.merchantDataValue as string).trim() !== "" &&
                typeof authNet.basilDataDescriptor === "string" && (authNet.basilDataDescriptor as string).trim() !== "" &&
                typeof authNet.basilDataValue === "string" && (authNet.basilDataValue as string).trim() !== "";
              const hasSingleToken =
                typeof authNet.dataDescriptor === "string" && (authNet.dataDescriptor as string).trim() !== "" &&
                typeof authNet.dataValue === "string" && (authNet.dataValue as string).trim() !== "";
              if (hasDualTokens) {
                // valid (save card payload)
              } else if (!hasSingleToken) {
                setAuthNet("Payment token invalid. Missing dataDescriptor or dataValue.");
                setIsPaymentProcessing(false);
                setIsPopupVisible(!isPopupVisible);
                return Promise.reject(new Error("Invalid authNet: missing dataDescriptor or dataValue"));
              }
            }

            const headers =
              !userDataString && !SignupData
                ? {
                    cardSave: saveCard,
                    isDelivery: delivery ? "True" : "False",
                    MID: merchantname,
                    timeZone: getCurrentTimezone(),
                  }
                : {
                    cardSave: saveCard,
                    isDelivery: delivery ? "True" : "False",
                    MID: merchantname,
                    Timezone: getCurrentTimezone(),
                  };
            return axios.post(baseurl + apiurlone, payload, { headers });
          })
          .then((res) => {
            const response = res;
            const message =
              (response &&
                (response.data as Record<string, unknown>)) ??
              undefined;
              console.log(message,"message123");
            const transIdArray = !delivery
              ? message
              : (message?.checkoutResponse as TransIdResponse);
            const transId = transIdArray?.transId;
            const tipsAndFees = message?.tipsAndFeesResponse as TransIdResponse | undefined;
            const checkoutSuccess = transIdArray?.success === true;
            const tipsAndFeesSuccess = tipsAndFees?.success === true;

            if (message?.["Error Code: "]) {
              const ErrorAuth: string = message?.["Error Code: "] as string;
              if (ErrorAuth) {
                const errorMsg = ErrorAuth.split("\n")[1];
                setAuthNet(errorMsg);
              }
            } else if (!delivery && transId === "0") {
              setAuthNet(
                "Issue authorizing payment. Please check the card details and try again"
              );
            } else if (delivery && (!checkoutSuccess || !tipsAndFeesSuccess)) {
              if (transId === "0" || tipsAndFees?.transId === "0") {
                setAuthNet(
                  "Issue authorizing payment. Please check the card details and try again"
                );
              } else {
                setAuthNet("Payment could not be completed. Please try again.");
              }
            }

            const Auth: string = delivery
              ? (transIdArray?.description as string) ?? (message as any)?.description
              : (message as any)?.description;
            const isApproved =
              Auth === "This transaction has been approved." ||
              (delivery && checkoutSuccess && tipsAndFeesSuccess);

            if (isApproved) {
              setGreenFlag(true);
              setIsPopupVisible(!isPopupVisible);
              const RequiredData = message as any;
              if (
                (!user || user === null) &&
                (message as any)?.["NewAuthNetProfile"]
              ) {
                const newCustomerId = (
                  (message as any)["NewAuthNetProfile"] as {
                    customerProfileId: string;
                  }
                ).customerProfileId;
                Cookies.set("user", newCustomerId);
              }
              setAuthNet(
                (transIdArray?.description as string) ||
                  Auth ||
                  "This transaction has been approved."
              );

              if (delivery && checkoutSuccess && tipsAndFeesSuccess && transId && tipsAndFees?.transId && quoteId) {
                const apiurlmerchant = "/kitchenHub/delivery/test/orders";
                const bo = orderDataUpdated?.basilOrder ?? {};
                const deliveryOrderPayload = {
                  kitchenHub: {
                    deliveryFee: Math.round((Number(deliveryFee) || 0) * 100),
                    driver_tip: selectedDeliveryTip
                      ? Math.round(finalDeliveryTip(selectedDeliveryTip) * 100)
                      : 0,
                    quote_id: quoteId,
                    customer_name: data?.delivery?.deliverTo ?? "",
                  },
                  basilOrder: {
                    transId,
                    basilTransId: tipsAndFees.transId,
                    customerInfo: {
                      firstName: bo.customerInfo?.firstName ?? "",
                      lastName: bo.customerInfo?.lastName ?? "",
                      email: bo.customerInfo?.email ?? "",
                      phone: bo.customerInfo?.phone ?? "",
                      address_label: "Delivery",
                      dropoff_street: data?.delivery?.address1 ?? "",
                      dropoff_city: data?.delivery?.city ?? "",
                      dropoff_state: data?.delivery?.state ?? "",
                      dropoff_zip: data?.delivery?.zip ?? "",
                      dropoff_country: data?.delivery?.country ?? "USA",
                      address: "Delivery",
                    },
                    orderItemList: bo.orderItemList ?? [],
                    pickUpTime: bo.pickUpTime ?? "",
                    status: bo.status ?? "pending",
                    subTotal: bo.subTotal ?? String(subTotal.toFixed(2)),
                    tip: bo.tip ?? 0,
                    type: bo.type ?? "online",
                    discount: bo.discount ?? 0,
                    note: bo.note ?? "",
                  },
                };
                const deliveryHeaders = {
                  MID: merchantname,
                  isDelivery: "True",
                  Timezone: getCurrentTimezone(),
                };
                return axios
                  .post(baseurl + apiurlmerchant, deliveryOrderPayload, {
                    headers: deliveryHeaders,
                  })
                  .then((orderRes: any) => {
                    const resData = orderRes?.data ?? {};
                    const linkResponse = resData["Delivery Tracker Link"];
                    if (linkResponse != null && linkResponse !== "") {
                      setDeliveryLink(linkResponse);
                    }
                    const orderNo = resData?.orderNo ?? resData?.checkoutResponse?.orderNo ?? RequiredData?.orderNo ?? RequiredData?.checkoutResponse?.orderNo;
                    if (orderNo != null) {
                      setResponseData({ orderNo });
                    }
                    if (resData?.paymentResponse?.orderResponseBody?.description) {
                      setAuthNet(resData.paymentResponse.orderResponseBody.description);
                    }
                    setIsPaymentProcessing(false);
                    setIsPopupVisible(!isPopupVisible);
                    return orderRes;
                  })
                  .catch((err: Error) => {
                    setAuthNet(err?.message ?? "Delivery order could not be placed. Please contact support.");
                    setSomethingWrong(true);
                    setIsPaymentProcessing(false);
                    setIsPopupVisible(!isPopupVisible);
                  });
              }

              const requiredData: ResponseData = {
                orderNo: RequiredData?.orderNo ?? RequiredData?.checkoutResponse?.orderNo,
              };
              setResponseData(requiredData);
            } else if (Auth === undefined && (message as any)?.["Error Code: "]) {
              const ErrorAuth: string = (message as any)?.[
                "Error Code: "
              ] as string;
              if (ErrorAuth) {
                const errorMsg = ErrorAuth.split("\n")[1];
                setAuthNet(errorMsg);
              }
            }
            setIsPaymentProcessing(false);
            setIsPopupVisible(!isPopupVisible);
          })
          .catch((err: Error) => {
            setAuthNet(err?.message || "Payment tokenization failed.");
            setSomethingWrong(true);
            setIsPaymentProcessing(false);
            setIsPopupVisible(!isPopupVisible);
          });
          })
          .catch((err: Error) => {
            setAuthNet(err?.message || "Payment script did not load.");
            setSomethingWrong(true);
            setIsPaymentProcessing(false);
            setIsPopupVisible(!isPopupVisible);
          });
        return;
      }

      let response: AxiosResponse<unknown, any> | undefined;
      try {
        setSomethingWrong(false);
        if (!userDataString && !SignupData) {
          response = await axios.post(baseurl + apiurlone, orderDataUpdated, {
            headers: {
              cardSave: saveCard,
              isDelivery: delivery ? "True" : "False",
              MID: merchantname,
              timeZone: getCurrentTimezone(),
            },
          });
        } else if (!selectedCard && (userDataString || SignupData)) {
          response = await axios.post(baseurl + apiurlone, orderDataUpdated, {
            headers: {
              cardSave: saveCard,
              isDelivery: delivery ? "True" : "False",
              MID: merchantname,
              Timezone: getCurrentTimezone(),
            },
          });
        } else {
          response = await axios.post(baseurl + apiUrl, orderDataUpdated, {
            headers: {
              // cardSave: saveCard,
              isDelivery: delivery ? "True" : "False",
              MID: merchantname,
              Timezone: getCurrentTimezone(),
            },
          });
        }
      } catch (error) {
        setSomethingWrong(true);
        setIsPaymentProcessing(false);
        setIsPopupVisible(!isPopupVisible);
      }

      let message: Record<string, unknown> | undefined;
      message =
        (response && (response.data as Record<string, unknown>)) ?? undefined;

      // const Auth: string = !delivery ? (message["Auth Net: "] as string) : "";
      const transIdArray = !delivery
        ? message
        : (message?.checkoutResponse as TransIdResponse);
      const transId = (transIdArray?.transId ?? (transIdArray as any)?.saleGuid) as string | undefined;
      console.log("messageresponse", message?.orderNo);
      const deliveryTransIdArray =
        message?.tipsAndFeesResponse as DeliveryTransIdResponse;

      const deliverytransId = (deliveryTransIdArray?.transId ?? (deliveryTransIdArray as any)?.saleGuid) as string | undefined;
      const errorCode = transIdArray?.success;
      const deliveryErrorCode = deliveryTransIdArray?.success;
      if (message?.["Error Code: "] || errorCode || deliveryErrorCode) {
        const ErrorAuth: string = message?.["Error Code: "] as string;
        if (ErrorAuth) {
          const errorMsg = ErrorAuth.split("\n")[1];
          setAuthNet(errorMsg);
        }
      } else if (transId == "0" || deliverytransId == "0") {
        const ErrorAuth =
          "Issue authorizing payment. Please check the card details and try again";
        if (ErrorAuth) {
          const errorMsg = ErrorAuth;
          setAuthNet(errorMsg);
        }
      }
      if (
        transId &&
        quoteId &&
        transId != "0" &&
        deliverytransId &&
        deliverytransId != "0"
      ) {
        try {
          setGreenFlag(true);

          let responseCustomer: AxiosResponse<unknown, any>;

          const OrderCustomer = {
            kitchenHub: {
              merchant_id: Number(onlineDeliveryId),
              quote_id: quoteId,
              address_label: "Home",
              dropoff_street: data?.delivery?.address1,
              dropoff_city: data?.delivery?.city,
              dropoff_state: data?.delivery?.state,
              dropoff_zip: data?.delivery?.zip,
              dropoff_country: data?.delivery?.country,
              dropoff_suite: data?.delivery?.address2,
              dropoff_instructions: data?.delivery?.deliveryInstructions,
              customer_name: data?.delivery?.deliverTo,
              customer_phone: data?.delivery?.contact,
              subtotal: Number((subTotal * 100).toFixed(0)),
              deliveryFee: Number(deliveryFee),
              driver_tip: selectedDeliveryTip
                ? Math.round(finalDeliveryTip(selectedDeliveryTip) * 100)
                : 0,
            },
            authNet: {
              ...orderData.authNet, // Spread operator to include all fields from orderData.authNet
            },
            basilOrder: {
              transId: transId,
              basilTransId: deliverytransId,
              providerPickUpTime: pickUp.toString(),
              providerDeliveryTime: estimatedTime.toString(),
              provider: quoteProvider,

              ...orderData.basilOrder,
            },
          };
          const apiurlmerchant = "/kitchenHub/delivery/test/orders";

          responseCustomer = await axios.post(
            baseurl + apiurlmerchant,
            OrderCustomer,
            {
              headers: {
                MID: merchantname,
                cardSave: saveCard,
                isDelivery: delivery ? "True" : "False",
                customerId: selectedCard?.customerPaymentProfileId ? user : "",
                Timezone: getCurrentTimezone(),
                Authorization: "1iIfU6btjHW85C6HvCIG5NGfU06evEck",
              },
            }
          );

          const bodyObject = (
            responseCustomer.data as { paymentResponse: PaymentResponseData }
          ).paymentResponse;
          const orderResponse =
            bodyObject?.orderResponseBody as TransIdResponse;
          // const feeResponse =
          //   bodyObject?.feeResponseBody as DeliveryTransIdResponse;
          console.log("bodyObject", bodyObject);
          const linkResponse = (
            responseCustomer.data as { ["Delivery Tracker Link"]: string }
          )["Delivery Tracker Link"];
          if (
            linkResponse !== null &&
            linkResponse !== undefined &&
            linkResponse !== ""
          ) {
            setDeliveryLink(linkResponse);
          }
          //setGreenFlag(true);

          if (bodyObject?.success === true) {
            setGreenFlag(true);
            setIsPopupVisible(!isPopupVisible);
            setAuthNet(orderResponse?.description);
            // const RequiredData = (orderResponse as any)["Basil Order"];
            const RequiredData = orderResponse as any;
            if (
              (!user || user === null) &&
              (orderResponse as any)["NewAuthNetProfile"]
            ) {
              const newCustomerId = (
                (orderResponse as any)["NewAuthNetProfile"] as {
                  customerProfileId: string;
                }
              ).customerProfileId;
              Cookies.set("user", newCustomerId);
            }

            const requiredData: ResponseData = {
              // totalAmount: RequiredData.totalAmount,
              orderNo: RequiredData?.ordeNo,
            };

            setResponseData(requiredData);
          } else {
            setGreenFlag(false); // Reset the flag if there's an error
            setErrorMessage("Something went wrong. Please try again.");
          }
        } catch (error) {
          console.error("Error occurred during the API call:", error);
          // Optionally, you can display an error message to the user or handle the error state in your UI
          setGreenFlag(false); // Reset the flag if there's an error
          setErrorMessage("Something went wrong. Please try again.");
        }
      }

      const Auth: string = !delivery
        ? ((message?.description as string) ?? (message?.success === true ? "This transaction has been approved." : ""))
        : authNet;

      if ((Auth === "This transaction has been approved." || message?.success === true) && !delivery) {
        setGreenFlag(true);
        setIsPopupVisible(!isPopupVisible);

        const RequiredData = message as any;

        if ((!user || user === null) && message?.["NewAuthNetProfile"]) {
          const newCustomerId = (
            message["NewAuthNetProfile"] as { customerProfileId: string }
          ).customerProfileId;
          Cookies.set("user", newCustomerId);
        }

        const requiredData: ResponseData = {
          // totalAmount: RequiredData.totalAmount,
          orderNo: RequiredData?.orderNo,
        };
        setResponseData(requiredData);
        //setGreenFlag(true);
        setAuthNet(Auth);
      } else if (Auth === undefined) {
        const ErrorAuth: string = message?.["Error Code: "] as string;
        if (ErrorAuth) {
          const errorMsg = ErrorAuth.split("\n")[1];
          setAuthNet(errorMsg);
        }
      }

      setIsPaymentProcessing(false);
      setIsPopupVisible(!isPopupVisible);
      // reset();
    } catch (error) {
      console.error("Error submitting order:", error);
      setSomethingWrong(true);
      setIsPaymentProcessing(false);
    }
  };

  const NoteContent = () => {
    return (
      <>
        <div className="w-full rounded-2xl space-y-2.5">
          <h3 className="flex items-center justify-between w-full px-4 py-2 font-medium text-left bg-slate-100/80 hover:bg-slate-200/60 dark:bg-slate-800 dark:hover:bg-slate-700 rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-slate-500 focus-visible:ring-opacity-75 ">
            Add Note
          </h3>
          <textarea
            placeholder=""
            className="w-full h-20 px-4 py-2 border rounded-lg focus:outline-none focus:ring focus:ring-slate-500 focus:ring-opacity-75 dark:text-gray-100 dark:bg-gray-700"
            value={note}
            onChange={handleNoteChange}
          />
        </div>
      </>
    );
  };

  const allProductPrice = Products.reduce(
    (accumulator: number, currentValue: Product) =>
      accumulator + calculatingTotalPrice(currentValue),
    0
  );

  const amtTax = Products.reduce(
    (accumulator: number, currentValue: Product) => {
      const taxTotals: TaxTotal[] = calculatingTotalTax(currentValue);

      const totalTaxForProduct = taxTotals.reduce(
        (totalTax: number, taxTotal: TaxTotal) => totalTax + taxTotal.amount,
        0
      );
      return accumulator + totalTaxForProduct;
    },
    0
  );

  const finalTip = (selectedTip: string) => {
    let calculateTip = 0.0;
    if (selectedTip !== "custom") {
      calculateTip =
        (parseFloat(location.state ? subTotal : allProductPrice) +
          parseFloat(amtTax)) *
        calTip(selectedTip.toString());
    } else if (selectedTip === "custom") {
      if (customTip != null && customTip !== "") {
        calculateTip = parseFloat(customTip);
      } else {
        calculateTip = 0;
      }
    } else {
      calculateTip = 0;
    }

    return parseFloat(calculateTip.toFixed(2));
  };
  const finalDeliveryTip = (selectedDeliveryTip: string) => {
    let calculateTip = 0.0;
    if (selectedDeliveryTip !== "custom") {
      calculateTip =
        (parseFloat(location.state ? subTotal : allProductPrice) +
          parseFloat(amtTax)) *
        calDeliveryTip(selectedDeliveryTip.toString());
    } else if (selectedDeliveryTip === "custom") {
      if (customTip != null && customTip !== "") {
        calculateTip = parseFloat(customTip);
      } else {
        calculateTip = 0;
      }
    } else {
      calculateTip = 0;
    }

    return parseFloat(calculateTip.toFixed(2));
  };

  const taxnames = Products.reduce(
    (accumulator: string[], currentValue: Product) => {
      return [...accumulator, TaxName(currentValue)];
    },
    []
  );

  const taxnamelist: Set<string> = new Set();
  taxnames.forEach((tax: string[]) => {
    tax.forEach((taxName: string) => {
      taxnamelist.add(taxName);
    });
  });

  let totAmt = 0.0;
  if (selectedTip) {
    const tipAmount = finalTip(selectedTip).toFixed(2);
    const tax = amtTax.toFixed(2);
    totAmt =
      parseFloat(parseFloat(allProductPrice).toFixed(2)) +
      parseFloat(tax) +
      parseFloat(tipAmount) +
      storedOrderFee;
  } else if (selectedDeliveryTip) {
    const tipAmount = finalTip(selectedDeliveryTip).toFixed(2);
    const tax = amtTax.toFixed(2);
    totAmt =
      parseFloat(parseFloat(allProductPrice).toFixed(2)) +
      parseFloat(tax) +
      parseFloat(tipAmount) +
      storedOrderFee;
  } else {
    console.log(
      "allProductPrice",
      parseFloat(allProductPrice) + parseFloat(amtTax) + storedOrderFee
    );
    const tax = amtTax.toFixed(2);
    totAmt =
      parseFloat(parseFloat(allProductPrice).toFixed(2)) +
      parseFloat(tax) +
      storedOrderFee;
  }

  const [showTime, setShowTime] = useState("");
  useEffect(() => {
    let getTime = parseInt(Cookies.get("onlineOrderSettingsLeadTime") || "0");
    if (estimatedTime && delivery) {
      getTime = estimatedTime + getTime;
    } else {
      getTime = parseInt(Cookies.get("onlineOrderSettingsLeadTime") || "0");
    }
    let currentTime = new Date();

    currentTime.setMinutes(currentTime.getMinutes() + getTime);

    let hours: any = currentTime.getHours();
    let minutes: any = currentTime.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12;
    hours = hours ? hours : 12;

    hours = hours < 10 ? "0" + hours : hours;
    minutes = minutes < 10 ? "0" + minutes : minutes;

    let formattedTime = hours + ":" + minutes + " " + ampm;

    setShowTime(formattedTime);
  }, [Cookies.get("onlineOrderSettingsLeadTime"), estimatedTime, delivery]);

  return (
    <div className="nc-CheckoutPage">
      <Helmet>
        <title>Basil POS Online Ordering</title>
      </Helmet>
      <main className="container py-16 lg:pb-28 lg:pt-20 ">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitOrder)}>
            <div className="mb-10">
              <h2 className="block text-2xl sm:text-3xl lg:text-4xl font-semibold ">
                Checkout
              </h2>
              <div className="block mt-3 sm:mt-5 text-xs sm:text-sm font-medium text-slate-700 dark:text-slate-400">
                <Link to={`/${merchantname}`} className="">
                  Menu
                </Link>
                <span className="text-xs mx-1 sm:mx-1.5">/</span>
                <Link to={`/${merchantname}/cart`} className="">
                  Cart
                </Link>

                {!userDataString && !SignupData && (
                  <span className="text-xs mx-1 sm:mx-1.5">/</span>
                )}
                {!userDataString && !SignupData && (
                  <Link to={`/${merchantname}/userdetails`} className="">
                    User Details
                  </Link>
                )}
                <span className="text-xs mx-1 sm:mx-1.5">/</span>
                <span className="underline">Checkout</span>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row">
              <PaymentMethod
                auth={auth}
                selectedCard={selectedCard}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                handleSubmit={handleSubmit}
                userDataString={userDataString}
                setSelectedCard={setSelectedCard}
                saveCard={saveCard}
                setSaveCard={setSaveCard}
                setCarddata={setCarddata}
              />
           

              <div className="flex-shrink-0 border-t lg:border-t-0 lg:border-l border-slate-200 dark:border-slate-700 my-4 lg:my-0 lg:mx-10 xl:lg:mx-14 2xl:mx-16 ">
              
              </div>

              <OrderSummary
                products={Products}
                reOrderData={reOrderData}
                setHistoryOrders={setHistoryOrders}
                setsubTotal={setsubTotal}
                searchProduct={searchProduct}
                calculatingTotalPrice={calculatingTotalPrice} // Example function for calculating total price
                merchantname={merchantname ?? `${merchantname}`}
                toggleAccordion={toggleAccordion}
                isAccordionOpen={isAccordionOpen}
                selectTime={selectTime}
                pickUpTime={hadlepickUpTime}
                timeOptions={timeOptions as string[]}
                isAsap={isAsap}
                handleTipSelection={handleTipSelection}
                selectedTip={selectedTip}
                handleDeliveryTipSelection={handleDeliveryTipSelection}
                selectedDeliveryTip={selectedDeliveryTip}
                customTip={
                  typeof customTip === "string"
                    ? parseFloat(customTip)
                    : customTip
                }
                handleCustomTipChange={handleCustomTipChange}
                errorMessage={errorMessage}
                carterror={carterror}
                NoteContent={NoteContent}
                setDelivery={setDelivery}
                quoteId={quoteId}
                quoteProvider={quoteProvider}
                estimatedTime={estimatedTime}
                pickUp={pickUp}
                deliveryFee={deliveryFee}
                saveDelivery={handleSubmit(saveDelivery)}
                allProductPrice={allProductPrice}
                taxDisplayList={
                  Array.isArray(taxDisplayList)
                    ? taxDisplayList.map(String)
                    : []
                }
                taxDisplayTotal={
                  Array.isArray(taxDisplayTotal)
                    ? taxDisplayTotal.map(Number)
                    : []
                }
                finalTip={finalTip}
                finalDeliveryTip={finalDeliveryTip}
                storedOrderFee={storedOrderFee}
                storedOrderFeeLabel={storedOrderFeeLabel}
                totAmt={totAmt}
                deliveryAddress={deliveryAddress}
                isPaymentProcessing={isPaymentProcessing}
                isQuotesProcessing={isQuotesProcessing}
                confirmOrder={confirmDialog}
                noQuotes={noQuotes}
              />
            </div>
          </form>
        </FormProvider>
      </main>
      {confirmDialog && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          {/* Overlay */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: -1,
            }}
          />
          {/* Modal Content */}
          <div
            className={`w-11/12 max-w-md h-auto p-8 rounded-lg shadow-lg relative flex flex-col justify-center items-center ${
              isDark === "dark" || (isDarkMode === true && isDark === "system")
                ? "bg-gray-800 text-white"
                : "bg-white text-black"
            }`}
          >
            <p className="font-bold text-sm text-center mb-4">
              {
                "Delivery fees and tips will be charged separate from your order. These charges will show as Delivery Services on your credit card statement. Press OK to continue"
              }
            </p>
            <ButtonPrimary
              onClick={handleSubmit(submitOrder)}
              className={`font-bold py-2 px-4 mt-4 rounded ${
                isDark === "dark" ||
                (isDarkMode === true && isDark === "system")
                  ? "bg-gray-700 hover:bg-gray-600 text-white"
                  : "bg-black hover:bg-gray-700 text-white"
              }`}
            >
              Ok
            </ButtonPrimary>
          </div>
        </div>
      )}

      <DeliveryOptionPopup
        isDarkMode={isDarkMode}
        isDark={isDark}
        confirmDialog={confirmDialog}
        isPopupVisible={isPopupVisible}
        isModalOpen={isModalOpen}
        greenFlag={greenFlag}
        somethingWrong={somethingWrong}
        authNet={authNet}
        responseData={responseData}
        deliveryOptions={deliveryOptions}
        showTime={showTime}
        delivery={delivery}
        pickUpTime={pickUpTime}
        deliveryLink={deliveryLink}
        pause={pause}
        pauselabel={pauselabel}
        setIsModalOpen={setIsModalOpen}
        setIsPopupVisible={setIsPopupVisible}
        setQuoteId={setQuoteId}
        setQuoteProvider={setQuoteProvider}
        setEstimatedTime={setEstimatedTime}
        setPickUp={setPickUp}
        setDeliveryFee={setDeliveryFee}
        togglePopup={togglePopup}
        setPause={setPause}
      />

      {/* {isPopupVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: -1,
            }}
          />
          <div>
            {isModalOpen ? (
              <div className='bg-white dark:bg-gray-700 max-w-4xl h-auto p-8 rounded-lg shadow-lg relative flex flex-col justify-center items-center'>
                <button
                  className='absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl font-bold dark:hover:text-gray-100'
                  onClick={() => {
                    setIsModalOpen(false);
                    setIsPopupVisible(false);
                  }}
                >
                  &times;
                </button>
                <h3 className='font-bold text-base mb-4 text-center'>
                  Delivery Options
                </h3>
                <ul className='w-full space-y-4'>
                  {deliveryOptions.map((option: DeliveryOption) => (
                    <li
                      key={option.id}
                      onClick={() => {
                        setIsModalOpen(false);
                        setIsPopupVisible(!isPopupVisible);
                        setQuoteId(option.id);
                        setQuoteProvider(option.provider);
                        setEstimatedTime(option.delivery_mins_from_now);
                        setPickUp(option.pickup_mins_from_now);
                        setDeliveryFee(`${option.price}`);
                        // setGreenFlag(true);
                      }}
                      className='bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 p-4 rounded-lg shadow cursor-pointer flex flex-col justify-center items-start'
                    >
                      <p className='font-semibold'>
                        Provider : {option.provider}
                      </p>
                      <p>Price : ${option.price / 100}</p>
                   
                      <p>ETA : aprx. {option.delivery_mins_from_now} mins</p>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}

            {!isModalOpen && !greenFlag && isPopupVisible && !confirmDialog && (
              <div className='bg-white  dark:bg-gray-700 w-11/12 max-w-md h-auto p-8 rounded-lg shadow-lg relative flex flex-col justify-center items-center'>
                <p className='font-bold text-sm text-center mb-4'>
                  {authNet ? authNet : "Payment failed, please try again"}
                </p>
                <ButtonPrimary
                  onClick={togglePopup}
                  className='bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mt-4 rounded'
                >
                  Exit
                </ButtonPrimary>
              </div>
            )}

            {!isModalOpen &&
              greenFlag &&
              (somethingWrong === false ? (
                <div className='bg-white w-11/12  dark:bg-gray-700 max-w-md h-auto p-8 rounded-lg shadow-lg relative flex flex-col justify-center items-center'>
                  <h1 className='font-bold text-6xl mb-4 text-green-500 flex justify-center items-center'>
                    <FaCheckCircle />
                  </h1>
                  <h3 className='font-bold text-base mb-4 text-center'>
                    Order Placed Successfully
                  </h3>
                  <p className='font-bold text-sm text-center mb-4'>
                    {authNet}
                  </p>
                  <div className='flex flex-col sm:flex-row sm:space-x-4 text-center'>
                    <span>OrderNo: #{responseData?.orderNo}</span>
                    
                  </div>
                  {delivery === true && (
                    <>
                      <span mt-4 className='text-sm text-center'>
                        Your Order will be delivered by approximately {showTime}
                      </span>
                      <span mt-4 className='text-sm text-center'>
                        Please{" "}
                        <a
                          href={deliveryLink}
                          className='text-blue-500 underline'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Click here
                        </a>{" "}
                        to track your order
                      </span>
                    </>
                  )}
                  {delivery === false && (
                    <span mt-4 className='text-sm text-center'>
                      Your Order will be ready by approximately{" "}
                      {formatPickupTime(pickUpTime)}
                    </span>
                  )}
                  <ButtonPrimary
                    onClick={togglePopup}
                    className='bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mt-4 rounded'
                  >
                    Exit
                  </ButtonPrimary>
                </div>
              ) : (
                <div className='bg-white  dark:bg-gray-700 w-11/12 max-w-md h-auto p-8 rounded-lg shadow-lg relative flex flex-col justify-center items-center'>
                  <p className='font-bold text-sm text-center mb-4'>
                    Something went wrong, please try again.
                  </p>
                  <ButtonPrimary
                    onClick={togglePopup}
                    className='bg-black hover:bg-gray-700 text-white font-bold py-2 px-4 mt-4 rounded'
                  >
                    Exit
                  </ButtonPrimary>
                </div>
              ))}
          </div>
        </div>
      )}
      {isPopupVisible === false && pause === "1" && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
          onClick={() => setPause(null)}
        >
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: -1,
            }}
          />
          <div>{<div className='alert alert-red'>{pauselabel}</div>}</div>
        </div>
      )} */}
    </div>
  );
};

export default CheckoutPage;
